module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7030/images/default-avatar.png"